import {createContext} from 'react';

import {noop} from 'ramda-adjunct';

import {TextFieldContext} from './types';

export const textFieldCtx = createContext<TextFieldContext>({focusInput: noop});
